<template>
    <div class="darkbg" @click="changePage('')"></div>
    <div class="loginpage ">
      <div class="log-box">
        <div class="e-log-box">
          <div class="block">
            <div class="left_c title" style="justify-content: center; width: 100%">
               Terms & Conditions
            </div>
            
          </div>          
        </div>
        <div class="termScroll ">
                <span
                  v-bind:class="{ 'trusted-html': termContent !== '' }"
                  v-once
                  v-html="termContent"
                ></span>
              </div>
        <div class="info_div ">
          <div class="btn-div ">
            <div class="btn-box firstMargin " @click="confirmTerm(false)">Cancel</div>
            <div class="btn-box " @click="confirmTerm(true)">Confirm</div>  
          </div> 
        </div>   
      </div>      
    </div>
  </template>
  <script>
  import Request from '@/services/Request'
  import AlertDialog from '@/components/alertdialog.vue'
  import '@/assets/main.css'
  import { isValidEmail } from "@/utils/tool.js";
  
  export default {
    components: { AlertDialog },
    props:['termContent'],
    emits:['termConfirm'],
    data() {
      return {
      }
    },
    methods: {
        confirmTerm(t)
        {
            this.$emit('termConfirm',{checkedTerm:t,dialogVisible:false});
        },
        changePage()
        {

        }
    }
  }
  </script>
  
        
        
  <style lang="scss" scoped>
  .title {
    font-size: 14px;
    font-weight: bold;
  }
  
  .checkbox {
    background: #fff;
    width: 1.8rem;
    height: 1.8rem;
    border: 1px #ccc solid;
    border-radius: 3px;
    cursor: pointer;
    font-size:13px;
    color: white;
    font-weight: bold;
    display: flex;
    justify-content: center;
    align-items: center;
    align-content: center;
  }
  .agree {
    background: #4F6F52;
    border: 1px #4F6F52 solid;
    font-size:13px;
  }
  .noagree {
    background: #fff;
    border: 1px #4F6F52 solid;
  }
  .red-placeholder ::placeholder {
    /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: red !important;
    opacity: 1; /* Firefox */
  }
  
  .red-placeholder :-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: red !important;
  }
  
  .red-placeholder ::-ms-input-placeholder {
    /* Microsoft Edge */
    color: red !important;
  }
  .el-divider--horizontal {
    width: 60% !important;
    margin: 0 auto;
  }
  .log-success-box {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 813rpx;
    height: 782rpx;
    flex-shrink: 0;
    border-radius: 33px;
    border-radius: 33px;
    background: #fff;
    z-index: 99;
  }
  
  :deel(.el-dialog) {
    top: -75px;
    border-radius: 33px;
    .el-dialog__header {
      font-weight: bold;
      border: 0px solid red;
      padding-top: 30px;
      text-align: center;
      .el-dialog__headerbtn {
        font-size:26px;
        font-weight: 700;
        color: #000;
      }
    }
  }
  
  * {
    padding: 0;
  }
  
  .el-select-dropdown__item {
    padding: 0 20px;
  }
  

  .btn-box { 
    height: 3.8rem !important;
    line-height:3.8rem !important;
        margin-right:3px;
         width: 90%;
    
         padding:7px;
         background: #4F6F52;
         border-radius: 9px;
         opacity: 1;
         text-align: center;
         font-size:13px;
         font-family:Poppins;
         font-weight: 400;
         color: #ffffff;
         cursor: pointer;
       vertical-align: middle;
       display:flex;

       align-items: center;
       justify-content: center;
        
       }
  
  .log-box {
    margin-top: 0rpx;
    padding: 0 15px;
  
    .info_div{
   
      .btn-div{
        display: flex;
        align-items: center;
        justify-content: center;
    
        width: 100%;
  
        
      }
    }
    .forgrt-box {
      font-size:13px;
      font-family: Poppins;
      font-weight: 400;
      color: #4F6F52;
      cursor: pointer;
      margin-top: 10px;
  
      :deel(.el-checkbox) {
        .el-checkbox__inner {
          height: 16px;
          width: 16px;
          border-color: #aaa;
  
          border-radius: 2px;
        }
  
        .el-checkbox__input.is-checked .el-checkbox1__inner {
          background-color: #4F6F52;
          border-color: #aaa;
        }
  
        .el-checkbox__inner:hover {
          border-color: #aaa;
        }
  
        .el-checkbox__inner::after {
          top: 40%;
          left: 50%;
          transform: translate(-50%, -50%) scale(1.2) rotate(45deg);
        }
      } /**/
  
      div {
        font-size:13px;
        margin-left: 10px;
      }
    }
  
    :deep(.e-log-box) {
      .el-form {
        .el-form-item {
          vertical-align: middle;
          width: 50%;
          margin: 0;
          padding: 0px;
          border: 0px solid red;
          height: 65px;
          padding-right: 10px;
  
          .el-form-item__label {
            padding: 0;
          }
  
          .el-form-item__content {
            width: 100%;
  
            .el-date-editor--date {
              width: 100%;
            }
  
            .el-select {
              width: 100%;
            }
  
            .input-with-select {
              border: 2rpx solid #e9e9eb;
              border-radius: 99rpx;
              padding: 8rpx 14rpx 8rpx 0;
  
              &.el-input .el-input__inner {
                border: none;
                height: 40rpx;
                line-height: 40rpx;
                padding-left: 10px;
  
                &::placeholder {
                  color: #cfcfcf;
                }
              }
  
              .el-input-group__append {
                border-radius: 20rpx;
                font-weight: bold;
                cursor: pointer;
              }
            }
  
            .el-input {
              .el-input__inner {
                color: #333;
                border-radius: 10px;
                border: 0px solid red;
                background: #f5f5f5;
                padding-left: 10px;
                &::placeholder {
                  color: #a6a6a6;
                }
              }
  
              .el-input__suffix .el-input__icon.el-icon-arrow-up {
                color: #333;
              }
            }
          }
        }
  
        .el-input-group__append {
          background: #4F6F52;
          border: 1px solid #4F6F52;
        }
      }
    }
  
    .tab-box {
      padding: 9px;
      line-height: 19px;
      padding-left: 9px;
      width: 50%;
      float: left;
      .star {
        color: #4F6F52;
        padding-right: 5px;
      }
      .active {
        color: #4F6F52 !important;
      }
  
      .tab-name {
        font-size:13px;
        font-family: Poppins;
        font-weight: 400;
        color: #333333;
        margin-right: 25px;
        cursor: pointer;
      }
    }
  }
  
  .fb-btn {
    display: flex;
    margin-bottom: 10px;
    padding: 0 25px;
  
    div {
      flex: 1;
      height: 40px;
      border-radius: 25px;
      opacity: 1;
      border: 2px solid #a6a6a6;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size:13px;
      font-family: Poppins;
      font-weight: 400;
      color: #333333;
      cursor: pointer;
  
      &:first-child {
        margin-right: 10px;
      }
    }
  }
  
  .primaryColor {
    color: #4F6F52;
  }
  .custom-checkbox .el-checkbox__inner {
    border-color: #4F6F52 !important;
  }
  
  /* 当checkbox被hover时也改变边框颜色 */
  .custom-checkbox:hover .el-checkbox__inner {
    border-color: #4F6F52 !important;
  }
  
  /* 当checkbox被选中时，改变对号的颜色以适应新的边框颜色 */
  .custom-checkbox.is-checked .el-checkbox__inner {
    border-color: #4F6F52 !important;
  }
  
  .custom-checkbox.is-checked .el-checkbox__inner::after {
    border-color: #4F6F52 !important;
  }
  
  :deel(.el-cascader-node.in-active-path),
  :deel(.el-cascader-node.is-active),
  :deel(.el-cascader-node.is-selectable.in-checked-path) {
    color: #4F6F52;
  }
  
  :deel(.el-dropdown-menu__item) {
    padding: 10rpx 20rpx;
  
    text-align: center;
  }
  
  :deel(.share-adventure-wrap) {
    background-color: red;
  }
  
  :deel(.el-dropdown-menu__item:hover) {
    background-color: #4F6F52;
    color: #fff;
  }
  
  :deel(.el-dropdown-menu__item:focus) {
    background-color: #4F6F52;
    color: #fff;
  }
  
  :deel(.el-dropdown-menu) {
    padding: 0 !important;
  }
  .el-dropdown-menu {
    padding: 0 !important;
    border-radius: 15px;
    text-align: center;
    overflow: hidden;
  }
  
  .loginpage {
    position: fixed;
    width: 70%;
    top: 80px;
    height: 80%; /* 设置高度为80% */
    top: 10%; /* 剩下的20%高度在上下各分配10% */
    left: 50%;
    transform: translateX(-50%);
    background-color: white;
    padding: 20px;
    border: 1px solid #e5e5e5;
    border-radius: 25px;
    z-index: 99;
    background: #fff;
    padding: 15px;
    font-size:13px;
  }
  
  .country-item {
    display: flex;
    align-items: center;
  
    .country-img {
      width: 20rpx;
      height: 20rpx;
    }
  
    .country-txt {
      font-size:18px;
      margin-left: 3px;
    }
  }
  
  :deep(.pc_field) {
    display: block;
  }
  :deep(.m_field) {
    display: none;
  }


.log-box {
    display: flex;
    flex-direction: column;
    height: 100%; /* 占据父容器的全部高度 */
}

.info_div {
    display: flex;
    justify-content: space-between;
    padding: 10px 0;
}


.termScroll {
    flex: 1; /* 占据剩余的高度 */
    overflow-y: auto; /* 允许垂直滚动 */
    white-space: normal; /* 允许自动换行 */
    word-wrap: break-word; /* 强制单词换行 */
}

.termScroll span {
    display: block; /* 使 span 标签以块级元素呈现 */
    white-space: normal !important; /* 确保自动换行 */
    word-wrap: break-word!important;
}

  </style>
  
  
  
  <!-- 移动端 -->
  <style scoped>
  @media screen and (max-width: 750px) {
    
    .loginpage {
      top:20%;
    position: fixed;
    width: 80%;
    height:75%;
   z-index: 9999999;
  }
    :deep(.pc_field) {
      display: none;
    }
    :deep(.m_field) {
      display: block;
    }
  
    :deep(.el-date-editor.el-input),
    .el-date-editor.el-input__wrapper {
      height: 25px !important;
      font-size:13px;
      width: 100% !important;
    }
  
    .tab-box {
      padding: 0px;
    }
    html,
    body {
      line-height: 19px !important;
    }


    
  }
  </style>